import { render, staticRenderFns } from "./answerReply.vue?vue&type=template&id=89307ffa&scoped=true&"
import script from "./answerReply.vue?vue&type=script&lang=js&"
export * from "./answerReply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89307ffa",
  null
  
)

export default component.exports